/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
// import { ReactComponent as TrashIcon } from 'Images/tool_trash.svg';

export const Wrapper = styled.div`
  display: flex;
  padding: 5px 7px;
`;
Wrapper.displayName = 'Wrapper';
